import axios, { AxiosError } from "axios";
import { getToken } from "./localStorage";

type API_METHOD = "GET" | "POST" | "DELETE" | "PUT" | "PATCH";

// const API_BASE_URL = "https://api.superteamhr.com"
const API_BASE_URL = "https://atsapi.teamer.app";
export const COMMON = {
  apiBaseUrl() {
    if (API_BASE_URL) {
      return API_BASE_URL;
    }
  },
  stringFormat(s: string, ...args: any[]) {
    return s.replace(/{([0-9]+)}/g, (match, index) =>
      typeof args[index] === "undefined" ? match : args[index],
    );
  },
};

//const token = getToken(); // Retrieve token from localStorage
// const apiClient = axios.create({
//     baseURL: COMMON.apiBaseUrl(),
//     headers: {
//         'Content-type': 'application/json',
//         'Authorization': `Bearer ${token}`
//     },
//     withCredentials: true
// });

// Create axios instance
const apiClient = axios.create({
  baseURL: COMMON.apiBaseUrl(),
  withCredentials: true,
});

//  Add token dynamically on every request (correct way)
apiClient.interceptors.request.use((config: any) => {
  const token = getToken(); // always fresh token
  config.headers = config.headers || {};
  config.headers["Content-Type"] = "application/json";

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }

  return config;
});

// Global response error formatting
apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    return Promise.reject(error);
  },
);

const _baseRequest = (
  url: string,
  method: API_METHOD = "GET",
  data?: object,
  headers?: Record<string, string>,
): Promise<any> => {
  return apiClient
    .request({
      method,
      url,
      data,
      headers,
    })
    .then((response) => response.data)
    .catch((err: any) => {

      // 2. Safely extract the server data, checking multiple possible locations
      const serverData = err.response?.data || err.data;
      const serverStatus = err.response?.status || err.status || -1;

      return Promise.reject({
        name: err.name,
        // 3. Immediately set the message to the server's message if it exists
        message: serverData?.message || err.message, 
        status: serverStatus,
        data: serverData,
      });
    });
};

// Create axios instance
const apiClientFormData = axios.create({
  baseURL: COMMON.apiBaseUrl(),
  withCredentials: true,
});

//  Add token dynamically on every request (correct way)
apiClientFormData.interceptors.request.use((config: any) => {
  const token = getToken(); // always fresh token
  config.headers = config.headers || {};
  // config.headers["Content-Type"] = "application/json";

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }

  return config;
});

// Global response error formatting
apiClientFormData.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    return Promise.reject({
      name: error.name,
      message: error.message,
      status: error.response?.status || -1,
      data: error.response?.data,
    });
  },
);

const _baseRequestFormData = (
  url: string,
  method: API_METHOD = "GET",
  data?: object,
  headers?: Record<string, string>,
): Promise<any> => {
  return apiClientFormData
    .request({
      method,
      url,
      data,
      headers,
    })
    .then((response) => response.data)

    .catch((err: AxiosError | Error) =>
      Promise.reject({
        name: err.name,
        message: err.message,
        status: (err as AxiosError).response?.status || -1,
        data: (err as AxiosError).response?.data,
      }),
    );
};

export { _baseRequest, _baseRequestFormData };
